<template>
  <div class="apply-status">
    <div :class="`status-box ${getIndicatorStatusClass()}`">
      <div class="status-indicator" />
      <div v-if="(applyData.status > 30 && applyData.status < 37) || applyData.status === 38">
        <div>{{ $t('user.Panel Result') }}:</div>
        <div>{{ getStatusText() }}</div>
      </div>
      <span v-else>{{ getStatusText() }}</span>
    </div>
  </div>
</template>
<script>
  const statusDict = {
    '-1': 'Disapprove for Panel',
    0: 'No Application',
    1: 'Pending',
    2: 'Approve for Panel',
    10: 'Reopen',
    31: 'Promotion',
    32: 'Salary Adjustment',
    33: 'Transfer',
    34: 'Try Again Next Time',
    37: 'No show',
    38: 'No Participation_Not Win',
    40: 'Resigned',
  }

  export default {
    name: 'ApplyStatusColumn',
    props: {
      data: {
        required: true,
      },
    },
    components: {},
    data() {
      return {
        applyData: { ...this.data }, // 创建副本，不直接修改 props
      }
    },
    watch: {
      data: {
        handler(newData) {
          this.applyData = { ...newData }
        },
        deep: true,
      },
    },
    methods: {
      getStatusText() {
        // 优先使用原始 result 字段（评语），否则使用 status 对应的文本
        if (this.applyData.result && !statusDict[this.applyData.status]) {
          return this.applyData.result
        }
        return this.$t('user.' + (statusDict[this.applyData.status] || this.applyData.result || ''))
      },
      getIndicatorStatusClass() {
        const status = +this.applyData.status
        if (status === -1) {
          return 'error'
        } else if (status === 0) {
          return 'notapply'
        } else if (status <= 1) {
          return 'pending'
        } else if (status === 2) {
          return 'success'
        } else if (status === 10) {
          return 'reopen'
        } else if ((status > 30 && status < 37) || status === 38) {
          return 'result'
        } else if (status === 37) {
          return 'noshow'
        } else if (status === 40) {
          return 'resigned'
        }
      },
    },
  }
</script>
<style lang="less">
  @import url('@/styles/params.less');
  .status-box {
    display: flex;
    align-items: center;
    // justify-content: center;
    .status-indicator {
      width: 8px;
      height: 8px;
      min-width: 8px;
      border-radius: 100%;
      background-color: #ac7f40;
      margin-right: 8px;
    }
    &.notapply {
      color: #999;
      .status-indicator {
        background-color: #999;
      }
    }
    &.result {
      .status-indicator {
        background-color: #ac7f40;
      }
    }
    &.success {
      .status-indicator {
        background-color: #43a047;
      }
    }
    &.error {
      .status-indicator {
        background-color: #f44336;
      }
    }
    &.pending,
    &.reopen {
      .status-indicator {
        background-color: #faba16;
      }
    }

    &.noshow,
    &.resigned {
      .status-indicator {
        background-color: #fa8c16;
      }
    }
  }
</style>
